import {Observable, from} from 'rxjs';
import {RestQueryParams} from '../base/queryParams';
import {API_URL} from '../../config/entrypoint';

export function fetchDownloadHistoricalJobsAPI(authToken: string, params: RestQueryParams): Observable<any> {
    const url = '/api/jobs/historical_listing_download';
    const parmsStr = params.prepareQuery();

    return from(
        fetch(API_URL + url + parmsStr, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + authToken,
            },
        })
    );
}
